export const EMAIL_OTP_REQUEST_MINUTES = 3;

export const LOGIN_TYPE = {
    learner: 'Learner',
    administrator: 'Administrator'
};

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 10
};

export const TRIAL_REQUEST_TAGS = ['Active', 'Approved', 'Declined'];

export const quizCategoryColors = {
    learning: '#efd66f',
    reading: '#ed6dad',
    writing: '#4ea9cb',
    oralcommunication: '#a469d1',
    numeracy: '#19a65b'
};

export const deploymentTags = ['Overdue', 'Disabled', 'Standard', 'TAFE', 'Usage Exceeded', 'Storage Exceeded'];

export const paginationValues = [5, 10, 25, 50, 100, 200];
export const SUPPORT_EMAIL = {
    default: 'support',
    domain: process.env.REACT_APP_SUPPORT_EMAIL_DOMAIN || 'tlrg.com.au'
};
export const ROLES = ['Administrator', 'Analyst', 'Intake Assistant', 'Enrolment Officer', 'Compliance Manager', 'Auditor'];

export const CHECK_SESSION_ROUTE = '/auth/me';

export const FORM_GRID_SPACING = 2;

export const IMG_LOGO_SIZE = {
    xs: {
        width: 400,
        height: 200
    },
    sm: {
        width: 470,
        height: 230
    },
    md: {
        width: 650,
        height: 250
    },
    lg: {
        width: 680,
        height: 280
    },
    xl: {
        width: 700,
        height: 300
    }
};

export const DEPLOYMENT_REQUEST_TAGS = ['Active', 'Declined'];

export const DEPLOYMENT_REQUEST_MODAL_MODES = Object.freeze({
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    VIEW_APPROVAL: 'VIEW_APPROVAL',
    VIEW: 'VIEW'
});

export const DEFAULT_LOGO_URL = 'https://rpl-robot.s3.ap-southeast-2.amazonaws.com/assets/images/rpl-robot-logo-transparent-bg.png';

export const SUBDOMAIN_REGEX =
    /^(?=.{1,253}$)(?!.*--)(?:[a-zA-Z][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?)(?:\.(?!-)[a-zA-Z][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?)*$/;

export const PLAN_DEFAULTS = {
    STANDARD: {
        storage: 25,
        rpl: 5,
        users: 'unlimited'
    },
    TAFE: {
        storage: 500,
        rpl: 2000,
        users: 'unlimited'
    }
};
